import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Tarea, TareaVacia } from '../../../pages/tareas/models'

/**
 * Estado temporal de tareas usado por tarjetas y modales que comparten una lista activa.
 */
export const tareasSlice = createSlice({
  name: 'tarea',
  initialState: TareaVacia
  ,
  reducers: {
    cargarTareas: (state, action: PayloadAction<Tarea[]>) => ({
      ...state,
      tareas: action.payload,
    }),
  },
})

export const { cargarTareas } = tareasSlice.actions

export default tareasSlice.reducer
